import _ from 'lodash';
import { handleActions, combineActions } from 'redux-actions';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  byConversationId: {},
  isLoading: false,
  error: null
};

/**
 *
 * Example of the state tree:
 *  byConversationId: {
 *    42: {
 *      data: [...],
 *      count: 2
 *    }
 *  }
 */

export default handleActions(
  {
    [combineActions(actionTypes.GET_MESSAGES_START, actionTypes.SEND_MESSAGE_START)]: state => ({
      ...state,
      isLoading: true,
      error: null
    }),
    [combineActions(actionTypes.SEND_MESSAGE_SUCCESS, actionTypes.PUSH_SINGLE_MESSAGE)]: (state, action) => ({
      ...state,
      byConversationId: _.mergeWith({}, state.byConversationId, action.entities, function (value, src) {
        if (_.isArray(value)) {
          if (src) {
            return _.uniqBy(value.concat(src), 'id');
          }

          return value;
        }
      }),
      isLoading: false,
      error: null
    }),
    [actionTypes.GET_MESSAGES_SUCCESS]: (state, action) => ({
      ...state,
      byConversationId: _.mergeWith({}, state.byConversationId, action.entities, function (value, src) {
        if (_.isArray(value)) {
          if (src) {
            return _.uniqBy(src.reverse().concat(value), 'id');
          }

          return value;
        }
      }),
      isLoading: false,
      error: null
    }),
    [actionTypes.SET_MESSAGES]: (state, action) => ({
      ...state,
      byConversationId: _.mergeWith({}, state.byConversationId, action.entities, function (value, src) {
        if (_.isArray(value) && _.isArray(src)) {
          return src;
        }
      }),
      isLoading: false,
      error: null
    }),
    [combineActions(actionTypes.GET_MESSAGES_ERROR, actionTypes.SEND_MESSAGE_ERROR)]: (state, action) => ({
      ...state,
      isLoading: false,
      error: action.error
    }),
    [actionTypes.CLEAR_CONVERSATIONS_HISTORY]: () => initialState
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/conversationMessages.js